import Header from '@ui/elements/Header'
import { useTranslation } from 'react-i18next'

export default function IntroAvatarHeader() {
  const { t } = useTranslation(['intro'])
  const text = 'intro:avatar'

  return (
    <Header title={t(`${text}.header.title`)} desc={t(`${text}.header.desc`)} />
  )
}
